import React from 'react'
import Grid from '@material-ui/core/Grid'

import './style.css'

const PrimaryInfo = (props) => {
  const { icon, content, style } = props
  return <Grid
    item
    className="primary-info"
    style={style}
  >
    {icon}
    <div className="info-content">{content}</div>
  </Grid>
}
export default PrimaryInfo


// WEBPACK FOOTER //
// ./src/components/PrimaryInfo/index.js